export const BASE_URL = 'audience-targeting/v1/saved-audiences';
export const ANALYTICS_URL = 'audience-targeting/v1/audiences/analytics';
export const CRM_SEARCH_URL = '/crm-search/search';
export const CRM_USAGES_URL = 'crm-usages/v2/usages';
export const CRM_OBJECTS_URL = 'inbounddb-objects/v1/crm-objects';